






































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'
moment.locale('es-MX')

@Component
export default class PrintResumenVenta extends Vue {
  @Prop({ type: Object })
  private printInfo!: any
  @Prop({ type: Boolean })
  private printNow!: boolean

  private name: string = 'PrintResumenVenta'
  private isCopyMSG: string = 'ESTO ES UNA COPIA SIN VALOR'

  private styleTHInfo: string = 'border-style:solid;border-color:black;border-width:1px;background: #283593;color: #FFF;'
  private styleTHInfoBlank: string = 'border-style:solid;border-color:black;border-width:1px;'
  private styleTHFecha: string = 'width: 21%; border-style:solid;border-color:black;border-width:1px;background: #283593;color: #FFF;'
  private styleTH: string = 'width: 15%; border-style:solid;border-color:black;border-width:1px;background: #283593;color: #FFF;'
  private styleTD: string = 'border-style:solid;border-color:black;border-width:1px;'
  private styleTDTotal: string = 'border-style:solid;border-color:black;border-width:1px;background: #E3F2FD;'
  private styleTHCategoria: string = 'width: 100%;border-style:solid;border-color:black;border-width:1px;background: #283593;color: #FFF;'

  @Watch('printInfo')
  private async watchPrintInfo (v: any) {
    console.log('watchPrintInfo :: ', v)
    if (v) {
      await setTimeout(async () => {
        // @ts-ignore: Unreachable code error
        await this.$htmlToPaper('printMeVentasResume')
      }, 100)
      console.log('Finish Print')
    }
  }

  private totalVentas (items: any[]) {
    let res: number = 0
    items.forEach((item: any) => {
      if (item.isCancel === null) {
        res = parseFloat(item.amountPay) + parseFloat(res.toString())
      }
    })
    return res.toFixed(2)
  }

  private totalVentasCancelado (items: any[]) {
    let res: number = 0
    items.forEach((item: any) => {
      if (item.isCancel !== null) {
        res = parseFloat(item.amountPay) + parseFloat(res.toString())
      }
    })
    return res.toFixed(2)
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
  }
}
